module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/moons-cddaab69898cab2428471370631320d6.svg";